(function() {
  function swiperInit() {
    // Initialize sub-slider (thumbnail slider)
    function subSliderInit(destroy) {
      const productMediaSublist = document.querySelector('.js-media-sublist');
      
      if (productMediaSublist) {
        if (destroy) {
          if (productMediaSublist.swiper) {
            productMediaSublist.swiper.destroy();
          }
        }
        
        new Swiper(productMediaSublist, {
          direction: 'vertical',
          slidesPerView: 'auto',
          spaceBetween: 8,
          watchSlidesProgress: true
        });
      }
    }

    // Initialize main product slider
    function sliderInit(destroy) {
      const productMediaList = document.querySelector('.js-media-list');
      
      if (productMediaList) {
        if (destroy) {
          if (productMediaList.swiper) {
            productMediaList.swiper.destroy();
          }
        }

        new Swiper(productMediaList, {
          slidesPerView: 1,
          spaceBetween: 0,
          watchSlidesProgress: true,
          // Add autoplay configuration
          autoplay: {
            delay: 5000, // Delay between transitions (in ms)
            disableOnInteraction: false // Continue autoplay after user interaction
          },
          pagination: {
            el: '.product__pagination',
            type: 'bullets',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        });
      }
    }

    // Initialize popup slider
    function popupSliderInit(destroy) {
      const popupSlider = document.querySelector('.js-popup-slider');
      
      if (popupSlider) {
        if (destroy) {
          if (popupSlider.swiper) {
            popupSlider.swiper.destroy();
          }
        }

        new Swiper(popupSlider, {
          slidesPerView: 1,
          spaceBetween: 0,
          // Add autoplay configuration for popup slider
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.product__pagination',
            type: 'bullets',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        });
      }
    }

    subSliderInit(true);
    sliderInit(true);
    popupSliderInit(true);
  }

  // Initialize on page load
  swiperInit();

  // Re-initialize when Shopify section reloads
  document.addEventListener('shopify:section:load', function(e) {
    swiperInit();
  });

  // Re-initialize when variant changes
  document.addEventListener('variant:change', function(e) {
    swiperInit();
  });
})();